import { createApp } from 'vue'
import { createPinia } from 'pinia'
// import VueLazyload from 'vue-lazyload'
import VueLazyLoad from 'vue3-lazyload'

import App from './App.vue'
import router from './router'

import 'virtual:svg-icons-register'

import AppIcon from './ui/AppIcon/Icon.vue'

import './assets/main.css'
const app = createApp(App)

app.use(createPinia())

app.use(router)
app.use(VueLazyLoad, {
  // error: 'https://s1-static.huxiucdn.com/pro/pc/image/pro-loading.png', // 加载错误时候的图片
  // loading: 'https://s1-static.huxiucdn.com/pro/pc/image/pro-loading.png' // 加载中的图片
})
app.component('app-icon', AppIcon)
app.mount('#app')
